import { render, staticRenderFns } from "./page-manage.vue?vue&type=template&id=ab677b8c&scoped=true&"
import script from "./page-manage.vue?vue&type=script&lang=js&"
export * from "./page-manage.vue?vue&type=script&lang=js&"
import style0 from "./page-manage.vue?vue&type=style&index=0&id=ab677b8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab677b8c",
  null
  
)

export default component.exports